/* ======================================================================================
		INIT
====================================================================================== */




/* ======================================================================================
		FUNCTION
====================================================================================== */

let init_Func = function(){
	
	$('.secHero__visual').css({opacity:0});
	$('.secHeroBlock__logo').css({opacity:0});
	$('.secHeroBlock__period').css({opacity:0});
	$('.secHeroBlock__text').css({opacity:0});
	$('.secHeroBlock__chance').css({opacity:0});
	
	var firstAnimeFlag = false;
	initAnime_Page = function(){
		if(!firstAnimeFlag){
			firstAnimeFlag = true;
			firstAnimeFunc();
		}
	}
	function firstAnimeFunc(){
		gsap.set(".secHero__visual", { scale: 1.2 });
		gsap.to(".secHero__visual", { scale: 1, opacity: 1, duration: 1, ease: "power3.out" });
		
		gsap.set(".secHeroBlock__logo", { scale: 1.8 });
		gsap.to(".secHeroBlock__logo", { scale: 1, opacity: 1, duration: 0.5, delay:0.5, ease: "power3.out" });

		gsap.set(".secHeroBlock__period", { y: "-30%" });
		gsap.to(".secHeroBlock__period", { y: 0, opacity: 1, duration: 0.4, delay:0.9, ease:easingType.typeSP1 });
		
		gsap.set(".secHeroBlock__text", { y: "-10%" });
		gsap.to(".secHeroBlock__text", { y: 0, opacity: 1, duration: 0.4, delay:1.0, ease:easingType.typeSP1 });

		gsap.fromTo(".secHeroBlock__chance",  { scale: 1.5 }, { scale: 1, opacity: 1, duration: 0.5, delay:1.1, ease: "back.out(1.7)" });
	}

	document.querySelectorAll(".shopList__item").forEach((el, index) => {
		el.classList.add("trigger_BtT");
	});
	document.querySelectorAll(".itemBlock__privilege").forEach((el, index) => {
		el.classList.add("trigger_scale");
	});


	gsap.utils.toArray(".trigger_hl").forEach((el) => {
		gsap.from(el, {
			scale: 1.5,
			opacity: 0,
			duration: 0.7,
			ease: "power4.out",
			// スクロールトリガーの設定
			scrollTrigger: {
				trigger: el, // 対象物
				start: 'top center+=10%',
				//markers: true,
			},
		});
	});


	gsap.utils.toArray(".trigger_scale").forEach((el) => {
		gsap.from(el, {
			scale: 1.4,
			opacity: 0,
			duration: 0.5,
			ease: "power4.out",
			// スクロールトリガーの設定
			scrollTrigger: {
				trigger: el, // 対象物
				//start: 'top center',
				start: 'top center+=30%',
				//markers: true,
			},
		});
	});

	gsap.utils.toArray(".trigger_BtT").forEach((el) => {
		gsap.from(el, {
			y: 100,
			opacity: 0,
			duration: 1.0,
			ease: "power4.out",
			// スクロールトリガーの設定
			scrollTrigger: {
				trigger: el, // 対象物
				start: 'top center+=20%',
				//markers: true,
			},
		});
	});





	let lightbox = new PhotoSwipeLightbox({
		gallery: '.mapBlock',
		children: 'a',
		pswpModule: PhotoSwipe
	});
	lightbox.init();


	pageLoadFlag = true;
};


// FIXED POSITION
let checkPosi;
let $btnFollowing = $('#jsFollowing');
function fixedPosition(){
	let clearPoint = $('#contents').outerHeight() - $(window).outerHeight();
	let scrollTop = $(window).scrollTop();
	
	checkPosi = function(){
		clearPoint = $('#contents').outerHeight() - $(window).outerHeight();
		scrollTop = $(window).scrollTop();
		//console.log("clearPoint",clearPoint)
		//console.log("scrollTop",scrollTop)
		
		if(clearPoint > scrollTop){
			$btnFollowing.addClass('fixed');
		}else{
			$btnFollowing.removeClass('fixed');
		}
	}
	checkPosi();
	
	$(window).on('load.fixedPosi scroll.fixedPosi resize.fixedPosi',function(){
		checkPosi();
	}).trigger('load.fixedPosi').trigger('scroll.fixedPosi').trigger('resize.fixedPosi');
	
}



/* ======================================================================================
		ACTION
====================================================================================== */
$(function(){
	fixedPosition();
	init_Func();
	
	$(window).on('resize.loading', function(){
		$('#nowloading').css({'height':$(window).outerHeight() + 'px'});
	}).trigger('resize.loading');
	$(window).trigger('resize');
	
	
	var old_size = null;
	$(window).on('resize.env', function(){
		spSizeFlag = is_size();
		
		var size = spSizeFlag;	//サイズ.
		if(size == old_size)
			return;
		
		showLoading(true);
		imgChange();
		old_size = size;
		
		loadImgCheck(function(){
			showLoading(false);
		});
		
	}).trigger('resize.env');
	
});



